import { jsx as _jsx } from "react/jsx-runtime";
// CSS class variants: btn--primary, btn--ghost, btn--destructive, btn--coral, btn--lg
// Critical (PATTERNS.md line 320 + CONTEXT line 230): btn--destructive background = --btn-destructive-default
// = --status-rejected (#a82828), NOT coral. Reject modal confirm uses variant="destructive".
export function Button({ variant = "ghost", size = "default", className = "", children, ...rest }) {
    const sizeCls = size === "lg" ? "btn--lg" : "";
    return (_jsx("button", { className: `btn btn--${variant} ${sizeCls} ${className}`.trim(), ...rest, children: children }));
}
//# sourceMappingURL=Button.js.map